
import { Vue } from "vue-class-component";

export default class CmsBanner extends Vue {}
